export default __webpack_public_path__ + "img/send-now.4fbaa11e.svg";